

export class Study {
    Id: number;
    Name: string;

    constructor(id: number, name: string) { this.Id = id; this.Name = name; }

    static GetStudyName(id: number): string {
        switch (id) {
            case (1): return "Infrastructure";
            case (2): return "VITAL";
            case (3): return "NEURO";
            case (4): return "SLEEP";
            case (5): return "AUTONOMIC";
            case (6): return "ENERGIZE";
            default: return "Unknown";
        }
    }

    //sorts in-place, with Infrastructure and Unknown at end of list
    static SortByName(list: Study[]): void {
        list.sort((a: Study, b: Study) => {
            if (a.Id != 1 && b.Id != 1) { return a.Name.localeCompare(b.Name); }
            else if (a.Id == 1 && b.Id != 1) { return 1; }
            else if (a.Id != 1 && b.Id == 1) { return -1; }
            else return 0;
        });
    }

    static GetStudiesToShow(appendixIds: number[]): number[] {
        let studiesToShow: number[] = [];

        if (appendixIds.includes(1)) { studiesToShow.push(2); } //VITAL 
        if (appendixIds.includes(3)) { studiesToShow.push(3); } //NEURO
        if (appendixIds.includes(5) || appendixIds.includes(6)) { studiesToShow.push(4); } //SLEEP
        if (appendixIds.includes(8) || appendixIds.includes(9)) { studiesToShow.push(5); } //AUTO
        if (appendixIds.includes(11) || appendixIds.includes(12)) { studiesToShow.push(6); } //ENERGIZE

        return studiesToShow;
    }
}
